import { ColumnsType } from 'antd/lib/table';
import dayjs from 'dayjs';

export interface IClientFollowupData {
  client_id: number;
  employee_id: number;
  type: string;
  purpose: string;
  scheduled_at: string;
  status: string;
  feedback: string;
  next_follow_up: string;
  client_contacted_person: number;
  relationship_manager: string;
}

export const clientFollowupUtil = (): ColumnsType<IClientFollowupData> => {
  return [
    {
      title: 'SL.',
      dataIndex: 'key',
      key: 'key',
    },
    {
      title: 'Scheduled At',
      key: 'scheduled_at',
      render: (_, record) => {
        return record.scheduled_at && `${dayjs(record.scheduled_at).format('DD MMM YYYY')}`;
      },
    },
    {
      title: 'TYPE',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: 'Purpose',
      dataIndex: 'purpose',
      key: 'purpose',
    },
    {
      title: 'Feedback',
      dataIndex: 'feedback',
      key: 'feedback',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: 'Next Follow Up',
      key: 'next_follow_up',
      render: (_, record) => {
        return record.next_follow_up && `${dayjs(record.next_follow_up).format('DD MMM YYYY')}`;
      },
    },
  ];
};
